module.exports = __webpack_public_path__ + "img/wel_title-3.e5dd4c9a.png";